var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var HeadingTypeTwo = /** @class */ (function (_super) {
    __extends(HeadingTypeTwo, _super);
    function HeadingTypeTwo(props) {
        var _this = _super.call(this, props) || this;
        _this.baseClass = "rj-heading-2";
        return _this;
    }
    HeadingTypeTwo.prototype.render = function () {
        var modifier = this.props.modifier;
        var cls = this.baseClass +
            (modifier ? " " + this.baseClass + "--" + modifier : "");
        return (React.createElement("h4", { className: cls }, this.props.children));
    };
    return HeadingTypeTwo;
}(React.Component));
export { HeadingTypeTwo };
//# sourceMappingURL=HeadingTypeTwo.js.map